import createAction from '../../common/services/create-action';
import { setHasReportedAppLoaded } from '../../common/store/app-loaded/app-loaded-actions';

export const appLoaded = fedopsAppLoaded => () => (dispatch, getState) => {
  fedopsAppLoaded();
  dispatch(setHasReportedAppLoaded());
};
